/**
 * The component for the section "Get Started" in the home page.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright (c) Ircam Amplify 2025
 */

import { Link } from 'react-router-dom'
import HomePageIcon from '../HomePageIcon'
import './styles/get-started.css'

interface GetStartedCompProps {
  icon: string
  title: string
  link_description: string
  link_url: string
}

const GetStartedComp = (props: GetStartedCompProps) => {
  return (
    <div className="getStartedComponent">
      <HomePageIcon src={props.icon} alt={props.title} background="white" />
      <div className="title">{props.title}</div>
      <Link className="link" to={props.link_url}>
        {props.link_description}
      </Link>
    </div>
  )
}

export default GetStartedComp
